import React from 'react';
import cs from 'classnames';
import $$tracker from '@src/tracker';
import styles from './index.less';

const DOWNLOAD_STAGES = ['pre_download', 'beta_download'];
const CUSTOMER_SERVICE_URL = 'https://support.seasungames.cn/product/jxsjsy4';

const FloatQrcode = ({ store, omniDataHome = {}, onClickWebsite }) => {
  const onBackTop = () => store.setCurrentPage('home');
  const isDownloadStage = DOWNLOAD_STAGES.includes(omniDataHome.game_stage_config);
  const downloadQrUrl = omniDataHome.down_link?.floatQrcode || '';

  const onCustomerServiceClick = () => {
    $$tracker.scanCustomerService('侧边栏');
  };

  const renderAppointmentSidebar = () => (
    <div>
      <img className={styles.bg} src={require('./images/bg.png')} alt="扫码预约" />
      <div className={cs(styles.hover_box, styles.kefu)}>
        <img className={styles.kefu_img} src={require('./images/weixin.png')} alt="微信二维码" />
      </div>
      <div className={cs(styles.hover_box, styles.weixin)}>
        <img className={styles.weixin_img} src={require('./images/kefu.png')} alt="客服二维码" />
      </div>
    </div>
  );

  const renderDownloadSidebar = () => (
    <div className={styles.download_content}>
      <div className={styles.download_qrcode}>
        <img className={styles.download_qrcode_frame} src={require('./images/download-qrcode-frame.png')} alt="" />
        <span className={styles.download_qrcode_decoration} aria-hidden="true" />
        <div className={styles.download_qrcode_value}>{downloadQrUrl && <iframe src={downloadQrUrl} title="首页侧边扫码下载游戏" />}</div>
      </div>
      <img className={styles.download_title} src={require('./images/download-title.png')} alt="扫码下载游戏" />
      <button type="button" className={styles.download_action} onClick={onClickWebsite} aria-label="进入官网">
        <img src={require('./images/download-website.png')} alt="" />
      </button>
      <div className={styles.customer_service}>
        <a
          className={styles.download_action}
          href={CUSTOMER_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onCustomerServiceClick}
          aria-label="联系客服"
        >
          <img src={require('./images/download-customer-service.png')} alt="" />
        </a>
      </div>
      <div className={styles.official_wechat}>
        <button type="button" className={styles.download_action} aria-label="查看官方微信公众号二维码">
          <img src={require('./images/download-official-wechat.png')} alt="" />
        </button>
        <img className={styles.official_wechat_qrcode} src={require('./images/weixin.png')} alt="官方微信公众号二维码" />
      </div>
      <span className={styles.download_divider} aria-hidden="true" />
    </div>
  );

  return (
    <div className={cs(styles.float_qrcode, { [styles.download]: isDownloadStage })}>
      {isDownloadStage ? renderDownloadSidebar() : renderAppointmentSidebar()}
      <button type="button" className={styles.top_btn} onClick={onBackTop} aria-label="返回顶部" title="返回顶部">
        <img className={styles.top_img} src={require('./images/top.png')} alt="" />
      </button>
    </div>
  );
};

export default FloatQrcode;
